<template>
  <el-drawer
    :visible.sync="show"
    size="900px"
    :withHeader="false"
    :direction="direction"
    :modal-append-to-body="false"
    append-to-body
    :wrapperClosable="wrapperClosable"
    :before-close="handleClose"
    custom-class="mes-workorder-detail"
  >
    <div class="container flex column">
      <div>
        <div class="header flex align-items-center">
          <div class="bd flex column ellipsis">
            <div class="flex align-items-center">
              <span>{{ detail.workorder_no }}</span>
              <el-tooltip content="主工单" placement="top" class="ml-xs" v-if="detail.type == 1" >
                <icon-svg icon-class="maintask" style="font-size: 22px"/>
              </el-tooltip>
              <el-tooltip content="子工单" placement="top" class="ml-xs" v-else-if="detail.type == 2">
                <icon-svg icon-class="subtask" style="font-size: 22px"/>
              </el-tooltip>
            </div>
            
            <span class="font-20 text-bold ellipsis">{{ detail.workorder_title }}</span>
          </div>
          <div class="ft">
            <div v-if="detail.status == 0" class="tag-purple">待排产</div>
            <div v-else-if="detail.status == 10" class="tag-purple">待下发</div>
            <div v-else-if="detail.status == 20" class="tag-blue">已下发</div>
            <div v-else-if="detail.status == 30" class="tag-green">已开工</div>
            <div v-else-if="detail.status == 80" class="tag-green">待质检</div>
            <div v-else-if="detail.status == 90" class="tag-warning">待结单</div>
            <div v-else-if="detail.status == 100" class="tag-black">已结单</div>
          </div>
        </div>

        <div class="line"></div>

        <div class="body flex column">
          <div v-if="detail.mfg_no" class="flex align-items-center mb-sm">
            <span>制 号：</span>
            <span>{{ detail.mfg_no }}</span>
          </div>
          <div v-if="detail.material_no" class="flex align-items-center mb-sm">
            <span>部 件：</span>
            <span>{{ detail.material_no }} / {{ detail.material_title }}</span>
          </div>
          <div v-if="detail.process_no" class="flex align-items-center mb-sm">
            <span>工 序：</span>
            <span>{{ detail.process_no }} / {{ detail.process_title }}</span>
          </div>
          <div v-if="detail.station_title" class="flex align-items-center mb-sm">
            <span>工 位：</span>
            <span>{{ detail.station_title }}</span>
          </div>
          <div v-if="detail.remark" class="flex align-items-center">
            <span>备 注：</span>
            <span>{{ detail.remark }}</span>
          </div>
          <div class="display flex mt">
            <div class="item">
              <span class="mt-xs">派工数量</span>
              <span v-if="!detail.create_from" class="text-bold text-purple ellipsis">
                <span class="font-16">{{ detail.plan_num || 0 }}</span>
                <span v-show="detail.plan_num">件</span>
              </span>
              <span v-else class="text-bold">--</span>
            </div>
            <div class="item">
              <span class="mt-xs">额定工时</span>
              <span v-if="!detail.create_from" class="text-bold text-purple ellipsis">
                <span class="font-16">{{ detail.standard_hour || 0 }}</span>
                <span v-show="detail.standard_hour">{{ detail.standard_unit + '/件' }}</span>
              </span>
              <span v-else class="text-bold">--</span>
            </div>
            <div class="item">
              <span class="mt-xs">附加工时</span>
              <span v-if="!detail.create_from" class="text-bold text-purple ellipsis">
                <span class="font-16">{{ detail.add_hour || 0 }}</span>
                <span v-show="detail.add_hour">{{ detail.standard_unit }}</span>
              </span>
              <span v-else class="text-bold">--</span>
            </div>
            <div class="item">
              <span class="mt-xs">派工工时</span>
              <span v-if="!detail.create_from" class="text-bold text-purple ellipsis">
                <span class="font-16">{{ detail.plan_total_hour || 0 }}</span>
                <span v-show="detail.plan_total_hour">{{ detail.standard_unit }}</span>
              </span>
              <span v-else class="text-bold">--</span>
            </div>
            <div class="item">
              <span class="mt-xs">合格数</span>
              <span v-if="!detail.create_from" class="text-bold text-success ellipsis">
                <span class="font-16">{{ detail.non_defective_num || 0 }}</span>
                <span v-show="detail.non_defective_num">件</span>
              </span>
              <span v-else class="text-bold">--</span>
            </div>
            <div class="item">
              <span class="mt-xs">不合格数</span>
              <span v-if="!detail.create_from" class="text-bold ellipsis" :class="detail.defective_num ? 'text-danger' : 'text-black'">
                <span class="font-16">{{ detail.defective_num || 0 }}</span>
                <span v-show="detail.defective_num">件</span>
              </span>
              <span v-else class="text-bold">--</span>
            </div>
            <div class="item">
              <span class="mt-xs">报工工时</span>
              <span v-if="!detail.create_from" class="text-bold font-16 ellipsis" :class="detail.status == 100 ? 'text-success' : 'text-warning'">
                <span class="font-16">{{ detail.report_total_hour || 0 }}</span>
                <span v-show="detail.report_total_hour">{{ detail.standard_unit }}</span>
              </span>
              <span v-else class="text-bold">--</span>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-box">
        <el-tabs v-model="activeTab" type="card">
          <el-tab-pane label="进度详情" name="progress" class="steps-container">
            <div class="ct-wx-step">
              <div v-for="(item, i) in eventList" :key="'flow' + i" class="ct-wx-cell-list">
                <div :style="i == eventList.length - 1 ? 'border-left: 1px solid rgba(0,0,0,0);' : ''" class="ct-wx-cell-line">
                  <div v-if="item.type == 'current'" class="text-success">
                    <span class="mr-xs">{{ item.sub_title }}</span>
                  </div>
                  <div
                    v-for="(_item, _i) in item.events"
                    :key="_i"
                    class="flex align-items-flex-start mt-xs"
                    :class="[(item.type == 'current'|| item.type == 'future') && 'text-muted', item.type == 'history' && 'text-black']"
                  >
                    <div class="space-head">{{ _item.key }}</div>
                    <div v-if="_item.value">：</div>
                    <div v-if="_item.value" class="flex align-items-center">
                      <div v-if="_item.type == 'qcresult'" class="flex column">
                        <span v-if="_item.value.defective_num" class="text-danger">不合格 {{ _item.value.defective_num }} 件</span>
                        <span class="text-black">合格 {{ _item.value.non_defective_num }} 件</span>
                      </div>
                      <div v-else>{{ _item.value }}</div>
                    </div>
                  </div>
                </div>
                <div
                  :class="[item.type == 'current' && 'active',  item.type == 'history' && 'black',item.seal&&!item.seal.inspect_result&&'red']"
                  class="ct-wx-cell-tag"
                >{{ item.title }}</div>
                <f-seal v-if="item.seal&&item.seal.inspect_result" type="success" :time="item.seal.inspect_time" class="seal" />
                <f-seal v-else-if="item.seal&&!item.seal.inspect_result" type="fail" :time="item.seal.inspect_time" class="seal" />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="报工信息" name="report">
            <div v-if="reportList && reportList.length" class="report-card">
              <div
                v-for="item in reportList"
                :key="'info'+item.uid"
                :class="item.status ? 'success' : 'warning'"
                class="item flex align-items-center mt"
              >
                <div class="hd">
                  <f-user-avatar :user="item" class="image large ml-lg" />
                </div>
                <div class="bd ml-sm flex column">
                  <span class="mb-xs font-16">{{ item.username }}</span>
                  <span class="text-muted">
                    {{ item.endtime | parseTime('{y}-{m}-{d} {h}:{i}') }} {{ item.status ? '结算' :
                    '报工'
                    }} {{ item.report_hour }} {{ item.standard_unit }}
                  </span>
                </div>
                <div class="ft mr text-bold font-20">
                  <span v-if="item.status == 0" class="text-warning">待结算 {{ item.report_hour }} {{ item.standard_unit }}</span>
                  <span v-else class="text-success">+ {{ item.confirm_hour }} {{ item.standard_unit }}</span>
                </div>
              </div>
            </div>
            <div v-else class="flex-center column mt-lg">
              <img src="@/assets/empty.png" alt class="image huger" />
              <span>暂无数据</span>
            </div>
          </el-tab-pane>
          <el-tab-pane label="质检详情" name="quality">
            <div v-if="qualityList.length" class="quality-card">
              <div v-for="(item,index) in qualityList" :key="index" :class="item.inspect_result ? 'qualified' : 'unqualified'" class="item mt">
                <div class="mb-xs flex">
                  <div class="text-muted quality-title">质检时间</div>
                  <div>：</div>
                  <div>{{ item.inspect_time | parseTime('{y}-{m}-{d} {h}:{i}') }}</div>
                </div>
                <div class="mb-xs flex">
                  <div class="text-muted quality-title">负 责 人</div>
                  <div>：</div>
                  <div>{{ item.inspector.username }}</div>
                </div>
                <div class="mb-xs flex">
                  <div class="text-muted quality-title">质检结果</div>
                  <div>：</div>
                  <div>
                    <div v-if="Number(item.defective_num)" class="text-danger">不合格 {{ Number(item.defective_num) }} 件</div>
                    <div>合格 {{ Number(item.non_defective_num) }} 件</div>
                  </div>
                </div>
                <div v-for="(form,idx) in item.form_post" :key="idx">
                  <div class="mb-xs flex">
                    <div class="text-muted form-title">{{ form.title }}</div>
                    <div>：</div>
                    <div v-if="form.type == 10" class="flex">
                      <div v-for="picture in form.value" :key="picture.id" class="mr-sm">
                        <el-image class="" style="width: 40px; height: 40px" :src="picture.url" :preview-src-list="[picture.url]"></el-image>
                      </div>
                    </div>
                    <div v-else>{{ form.value }}</div>
                  </div>
                </div>
                <f-seal v-if="item.inspect_result && item.inspect_time" type="success" :time="item.inspect_time" class="seal" />
                <f-seal v-else-if="!item.inspect_result && item.inspect_time" type="fail" :time="item.inspect_time" class="seal" />
              </div>
            </div>
            <div v-else class="flex-center column mt-lg">
              <img src="@/assets/empty.png" alt class="image huger" />
              <span>暂无数据</span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- <div class="footbar-area flex-center">
      <el-button type='success' class="mr-lg" size="small">通过</el-button>
      <el-button class="mr-lg" type='warning' size="small">驳回</el-button>
      <el-button type='danger' plain size="small">报废</el-button>
    </div>-->
  </el-drawer>
</template>

<script>
import {
  getMesWorkorderApi,
  workorderFlowApi,
  workorderLogsApi,
} from "@/api/mes/workorderApi";

export default {
  name: "MesWorkorderDetail",
  data() {
    return {
      show: false,
      wrapperClosable: true,
      direction: "rtl",
      activeTab: "progress",

      detail: {},
      eventList: [],
      reportList: [],
      qualityList: [],
      // time: 1681808267,
      
    };
  },

  methods: {
    open(id) {
      this.show = true;
      this.fetchData(id);
    },

    fetchData(id) {
      getMesWorkorderApi({ workorderid: id }).then((res) => {
        if (!res.errno) {
          this.detail = res.data;
          this.reportList = res.data.operators;
        }
      });
      workorderFlowApi({ workorderid: id }).then((res) => {
        if (!res.errno) {
          this.eventList = res.data.list;
        }
      });
      workorderLogsApi({ workorderid: id }).then((res) => {
        if (!res.errno) {
          this.qualityList = res.data.list;
        }
      });
    },

    handleClose(done) {
      // 重置tab
      this.activeTab = "progress";
      this.eventList = [];
      done();
    },
  },
};
</script>

<style lang="scss">
.mes-workorder-detail {
  user-select: none;

  .footbar-area {
    padding: 10px 0;
    border-top: 1px solid #ccc;
    background-color: #fff;
  }

  .container {
    height: calc(100%);
    padding: 20px 30px 0;

    .header {
      height: 42px;
    }

    .tab-box {
      flex-grow: 1;
      position: relative;
      overflow: auto;
    }

    .tag-purple,
    .tag-blue,
    .tag-green,
    .tag-warning,
    .tag-black {
      color: #997bec;
      border: 1px solid #997bec;
      border-radius: 5px;
      padding: 5px 10px;
    }

    .tag-blue {
      color: #409eff;
      border: 1px solid #409eff;
    }

    .tag-green {
      color: #07c160;
      border: 1px solid #07c160;
    }

    .tag-warning {
      color: #e6a23c;
      border: 1px solid #e6a23c;
    }

    .tag-black {
      color: #000;
      border: 1px solid #000;
    }

    .line {
      width: 100%;
      height: 1px;
      margin: 20px 0;
      background-color: #e0e3ea;
    }

    .display {
      width: 100%;
      height: 90px;
      border-radius: 5px;
      background-color: #f8f9fc;
      padding: 10px 0;

      .item {
        padding-bottom: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        flex: 1;
        border-right: 1px solid #e0e3ea;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        &:last-child {
          border-right: 1px solid rgba(0, 0, 0, 0);
        }
      }
    }

    .el-tabs__header {
      position: sticky;
      top: 0px;
      padding-top: 30px;
      background: #fff;
      z-index: 99990;
    }

    .steps-container {
      // max-height: 530px;
      padding: 10px;

      /** steps样式 */
      .ct-wx-step {
        box-sizing: border-box;
        position: relative;

        .space-head {
          width: 56px;
          min-width: 56px;
          text-align: justify;
          text-align-last: justify;
        }

        .ct-wx-cell-list {
          position: relative;
          box-sizing: border-box;
          padding-left: 30px;
        }

        .ct-wx-cell-list .active {
          color: #07c160;
          border: 1px solid #07c160;
        }

        .ct-wx-cell-list .black {
          color: #101010;
          border: 1px solid #101010;
        }

        .ct-wx-cell-list .red {
          color: #f56c6c;
          border: 1px solid #f56c6c;
        }

        .ct-wx-cell-line {
          color: #ccc;
          border-left: 1px solid #e4e4e4;
          padding-top: 3px;
          padding-left: 60px;
          min-height: 120px;
          box-sizing: border-box;
        }

        .ct-wx-cell-tag {
          text-align: center;
          color: #ccc;
          width: 60px;
          height: 28px;
          line-height: 28px;
          border: 1px solid #e0e3ea;
          border-radius: 30px;
          background-color: #fff;
          position: absolute;
          top: 0;
          left: 0;
        }

        .seal {
          position: absolute;
          bottom: 20px;
          right: 10px;
        }
      }
    }

    .report-card {
      > .item {
        width: 100%;
        height: 80px;
        background-color: #f8f9fc;
        border-radius: 5px;
        overflow: hidden;
      }

      .item.success,
      .item.warning {
        position: relative;

        &::before {
          width: 4px;
          height: 100%;
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          background-color: #07c160;
        }
      }

      .item.warning {
        &::before {
          background-color: #e6a23c;
        }
      }
    }
    .quality-card {
      min-height: 150px;
      margin-bottom: 20px;
      > .item {
        padding: 15px 20px;
        width: 100%;
        // height: 230px;
        background-color: #f8f9fc;
        border-radius: 5px;
        overflow: hidden;
      }

      .item.qualified,
      .item.unqualified {
        position: relative;

        &::before {
          width: 4px;
          height: 100%;
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          background-color: rgba(64, 158, 255, 100);
        }
        .seal {
          position: absolute;
          top: 30px;
          right: 20px;
        }
      }

      .item.unqualified {
        &::before {
          background-color: rgba(245, 108, 108, 100);
        }
      }
    }
  }
}
.quality-title {
  width: 56px;
  min-width: 56px;
  text-align: justify;
  text-align-last: justify;
}
.form-title {
  min-width: 28px;
}
</style>